import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  significanceErrorSelector,
  significanceMetricSelector,
} from '../../../../../redux/selectors/builder';
import { setSignificanceMeasureMetric } from '../../../../../redux/slices/oldBuilder';
import {
  IMeasureFieldsFragment,
  MetricTypeKey,
} from '../../../../../utils/apollo/graphqlSchema';
import BuilderMeasureMenu from '../../../../../components/Builder/Measures/BuilderMeasureMenu';
import { assertCondition } from '../../../../../utils/types';
import DndDroppableZone from '../../../../../components/DndEntity/DndDroppableZone';
import {
  EntityDropzoneDataTypeEnum,
  ISignificanceDropzoneDataType,
} from '../../../../../components/DndEntity/validation';
import { EntityDropzoneType } from '../../../../../components/QuickAccessDictionary/DictionaryTabs/types';

const dropzoneId = `Significance-Control-Named-Measure-Dropzone`;

const SignificanceMeasureMetric = () => {
  const dispatch = useAppDispatch();

  const significanceMetric = useAppSelector(significanceMetricSelector);
  assertCondition(significanceMetric?.type === MetricTypeKey.Measure);
  const { measure } = significanceMetric;
  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'metricMeasure'),
  );

  const handleSelectNamedMeasure = (namedMeasure: IMeasureFieldsFragment) => {
    dispatch(setSignificanceMeasureMetric({ namedMeasure }));
  };
  const handleClear = () => {
    dispatch(setSignificanceMeasureMetric({ namedMeasure: null }));
  };

  return (
    <DndDroppableZone
      accepts={[EntityDropzoneType.Measures]}
      id={dropzoneId}
      data={
        {
          id: dropzoneId,
          type: EntityDropzoneDataTypeEnum.Significance,
        } satisfies ISignificanceDropzoneDataType
      }
      customMessage={measure ? 'Replace Measure' : 'Add Measure'}
    >
      <BuilderMeasureMenu
        defaultNamedMeasure={measure}
        onChange={handleSelectNamedMeasure}
        onClear={handleClear}
        // We do not allow rolling window with "All Time" time unit
        // Significance report always uses "All Time" time unit therefore
        // we filter measures with rolling control
        allowRollingControl={false}
        allowCompoundMeasure={true}
        isError={hasError}
      />
    </DndDroppableZone>
  );
};

export default SignificanceMeasureMetric;
